{
  "accessibility": {
    "namespace": "accessibility",
    "mapName": "accessibility",
    "featureType": "Component",
    "supportsComponentInnerElements": false,
    "supportsVariants": true,
    "isRelationalSplitFromQuery": true,
    "scopedSerializationKey": "scopedAccessibility",
    "query": "accessibilityQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "preventRefFetchFromViewer": true,
    "signature": "263a5a7dfea6ec95495d573a81fe9c17"
  },
  "anchors": {
    "namespace": "anchors",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "mapName": "anchors_data",
    "query": "anchorQuery",
    "featureType": "Component",
    "signature": "5da1729ad4a881c68aa598ed9f69f965"
  },
  "atomicScopes": {
    "namespace": "atomicScopes",
    "mapName": "atomicScopes",
    "supportsVariants": false,
    "isPublicViewerData": false,
    "signature": "a0212dca0d37ce4b164cb509c4fd3160"
  },
  "behaviors": {
    "mapName": "behaviors_data",
    "query": "behaviorQuery",
    "featureType": "Component",
    "namespace": "behaviors",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "signature": "fef7bf7601af1c70ad29bad6265de46a"
  },
  "bindings": {
    "namespace": "bindings",
    "mapName": "bindings",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "supportsVariants": false,
    "query": "bindingsQuery",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": false,
    "preventRefFetchFromViewer": true,
    "signature": "14f8804c90293b5eb2be853cb1ebf41c"
  },
  "classnames": {
    "namespace": "classnames",
    "mapName": "classnames",
    "featureType": "Component",
    "supportsComponentInnerElements": false,
    "supportsVariants": false,
    "query": "classnamesQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "preventRefFetchFromViewer": true,
    "signature": "76146f81704e25c8c5216ebb2824ba5b"
  },
  "connections": {
    "mapName": "connections_data",
    "query": "connectionQuery",
    "featureType": "Component",
    "namespace": "connections",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "signature": "04052522e4a1323f74cd2110932954b3"
  },
  "contentRole": {
    "mapName": "contentRole",
    "query": "contentRoleQuery",
    "featureType": "Component",
    "namespace": "contentRole",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "acd78a1cf35f2d7a802efd3d5172ef1f"
  },
  "contexts": {
    "namespace": "contexts",
    "mapName": "contexts",
    "featureType": "Component",
    "supportsComponentInnerElements": false,
    "supportsVariants": false,
    "query": "contextsQuery",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": false,
    "preventRefFetchFromViewer": true,
    "signature": "5cfb377257971400c0e7cb833ea5c08c"
  },
  "controllers": {
    "namespace": "controllers",
    "mapName": "controllers",
    "featureType": "Component",
    "supportsComponentInnerElements": false,
    "supportsVariants": false,
    "query": "controllersQuery",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": false,
    "preventRefFetchFromViewer": false,
    "signature": "b0f229ff30403bffed489af828c5c270"
  },
  "cursor": {
    "namespace": "cursor",
    "mapName": "cursor",
    "featureType": "Component",
    "supportsVariants": true,
    "isRelationalSplitFromQuery": true,
    "scopedSerializationKey": "scopedCursor",
    "query": "cursorQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "signature": "596e840b895f1c48502ca19eaf021133"
  },
  "data": {
    "mapName": "document_data",
    "query": "dataQuery",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "namespace": "data",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "overrideNamespace": "multilingualTranslations",
    "supportsRepeaterItem": true,
    "supportOverrides": true,
    "signature": "74431bce8b7d4a67331bf417d2d9b5c9"
  },
  "dependedBy": {
    "namespace": "dependedBy",
    "mapName": "dependedBy",
    "supportsVariants": false,
    "isPublicViewerData": true,
    "signature": "5bfd046ecb587b3f54f6677ed172a482"
  },
  "dependsOn": {
    "namespace": "dependsOn",
    "mapName": "dependsOn",
    "supportsVariants": false,
    "isPublicViewerData": true,
    "signature": "0fde84a224b05c7e2fca563e1961750c"
  },
  "design": {
    "mapName": "design_data",
    "query": "designQuery",
    "featureType": "Component",
    "namespace": "design",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportsRepeaterItem": true,
    "supportsVariants": true,
    "scopedSerializationKey": "scopedDesigns",
    "isRelationalSplitFromQuery": true,
    "supportOverrides": true,
    "signature": "7a1544955e56857cecff454b8d1bb623"
  },
  "discussions": {
    "mapName": "discussions",
    "query": "discussionsQuery",
    "featureType": "Component",
    "namespace": "discussions",
    "supportsVariants": true,
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "isRelationalSplitFromQuery": true,
    "signature": "c699722f19b1e5af8764932e7bf13b24"
  },
  "editorsettings": {
    "namespace": "editorsettings",
    "mapName": "editorsettings",
    "featureType": "Component",
    "supportsVariants": false,
    "query": "editorsettingsQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "dd0065212d157450f790480c3088bb36"
  },
  "effects": {
    "namespace": "effects",
    "mapName": "effects",
    "supportsVariants": true,
    "query": "effectsQuery",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "isRelationalSplitFromQuery": false,
    "scopedSerializationKey": "scopedEffects",
    "supportOverrides": true,
    "signature": "d9ceb6b4d3846da45922f962ee15ad8b"
  },
  "fixerVersions": {
    "namespace": "fixerVersions",
    "mapName": "fixerVersions",
    "supportsVariants": false,
    "featureType": "Page",
    "query": "fixerVersionsQuery",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "signature": "a0b0372ecfc729d4e42ec956415bcf65"
  },
  "grouping": {
    "mapName": "grouping",
    "query": "groupingQuery",
    "featureType": "Component",
    "namespace": "grouping",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "a63f1ed0b078b1eae90e347f9031c4ef"
  },
  "imageVisualEffects": {
    "namespace": "imageVisualEffects",
    "mapName": "imageVisualEffects",
    "supportsVariants": false,
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": false,
    "signature": "747c59ec0df456825c9953110bb78a6e"
  },
  "innerElements": {
    "namespace": "innerElements",
    "mapName": "innerElements",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "supportsVariants": false,
    "query": "innerElementsQuery",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": false,
    "signature": "59ff518091f7bc89b91af276d3e39dd6"
  },
  "intent": {
    "namespace": "intent",
    "mapName": "intent",
    "featureType": "Component",
    "supportsComponentInnerElements": false,
    "supportsVariants": false,
    "query": "intentQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": true,
    "supportOverrides": false,
    "signature": "cc07cfd3735d81f4f500177aee3e1077"
  },
  "layout": {
    "mapName": "layout_data",
    "supportsVariants": true,
    "scopedSerializationKey": "scopedLayouts",
    "query": "layoutQuery",
    "featureType": "Component",
    "namespace": "layout",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "isRelationalSplitFromQuery": true,
    "signature": "f0c70980155fbc557c1f43413773e9b2"
  },
  "layoutSettings": {
    "namespace": "layoutSettings",
    "mapName": "layoutSettings",
    "featureType": "Component",
    "supportsComponentInnerElements": false,
    "supportsVariants": true,
    "isRelationalSplitFromQuery": true,
    "scopedSerializationKey": "scopedLayoutSettings",
    "query": "layoutSettingsQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "preventRefFetchFromViewer": false,
    "signature": "e877f61c454520ff530edbc731d3980e"
  },
  "manifest": {
    "mapName": "manifest",
    "query": "manifestQuery",
    "featureType": "Component",
    "namespace": "manifest",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "f644c6367b19254698f642083d55a735"
  },
  "measurements": {
    "namespace": "measurements",
    "mapName": "measurements",
    "featureType": "Component",
    "supportsComponentInnerElements": false,
    "supportsVariants": false,
    "query": "measurementsQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "preventRefFetchFromViewer": false,
    "signature": "f554b5ff4298f53b9372fb9159465352"
  },
  "migration": {
    "mapName": "migration",
    "query": "migrationQuery",
    "featureType": "Component",
    "namespace": "migration",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "437af5838723b36a95238f420e062007"
  },
  "mobileHints": {
    "mapName": "mobile_hints",
    "query": "mobileHintsQuery",
    "featureType": "Component",
    "namespace": "mobileHints",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "signature": "563a50c0214f8c5495d0621770d696c2"
  },
  "naming": {
    "mapName": "naming",
    "query": "namingQuery",
    "featureType": "Component",
    "namespace": "naming",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "5ce2351a719aeeb2706d46eb69a03b0c"
  },
  "notifications": {
    "namespace": "notifications",
    "mapName": "notifications",
    "featureType": "Component",
    "supportsVariants": false,
    "query": "notificationsQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "5567fea6c4260fa0065535966e46a0e8"
  },
  "pageSections": {
    "namespace": "pageSections",
    "mapName": "pageSections",
    "supportsVariants": false,
    "query": "pageSectionsQuery",
    "featureType": "Component",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "51f7377e070550edf75655231cff141d"
  },
  "patterns": {
    "namespace": "patterns",
    "mapName": "patterns",
    "query": "patternsQuery",
    "featureType": "Repeater",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportsVariants": false,
    "supportOverrides": true,
    "signature": "38dc6d6e73901c4cae3ff3ccb036c0e4"
  },
  "presets": {
    "namespace": "presets",
    "mapName": "presets",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "supportsVariants": true,
    "isRelationalSplitFromQuery": true,
    "scopedSerializationKey": "scopedPresets",
    "query": "presetsQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "signature": "c4412fa37ba2939857239ce61dad9496"
  },
  "props": {
    "namespace": "props",
    "mapName": "component_properties",
    "dataTypeName": "prop",
    "query": "propertyQuery",
    "featureType": "Component",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "signature": "a43cb4cd966b21ecf7d04b0b7de617fa"
  },
  "reactions": {
    "namespace": "reactions",
    "mapName": "reactions",
    "supportsVariants": true,
    "scopedSerializationKey": "scopedReactions",
    "query": "reactionsQuery",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "isRelationalSplitFromQuery": true,
    "supportOverrides": true,
    "signature": "69c963bc60bbb29391672a149693b452"
  },
  "runtimeBindings": {
    "namespace": "runtimeBindings",
    "mapName": "runtimeBindings",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "supportsVariants": false,
    "query": "runtimeBindingsQuery",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": false,
    "preventRefFetchFromViewer": true,
    "signature": "b15d0dc683d3bd5b35e7f6790479d62d"
  },
  "slots": {
    "namespace": "slots",
    "mapName": "slots",
    "supportsVariants": false,
    "query": "slotsQuery",
    "featureType": "Component",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "supportsComponentInnerElements": true,
    "signature": "1161e29e16d3138cda2a322cef8175b5"
  },
  "source": {
    "namespace": "source",
    "mapName": "source",
    "featureType": "Component",
    "supportsVariants": false,
    "query": "sourceQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "0638798231010622b046bd5bf3dd190d"
  },
  "states": {
    "namespace": "states",
    "mapName": "states",
    "supportsVariants": false,
    "query": "statesQuery",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "signature": "dec6ea139198f4e5a98a8dcd507e2985"
  },
  "structure": {
    "namespace": "structure",
    "mapName": "structure",
    "aliases": [
      "DESKTOP",
      "MOBILE"
    ],
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": false,
    "signature": "a599cc551a13467b0985ed1377a8b9db"
  },
  "style": {
    "mapName": "theme_data",
    "dataTypeName": "theme",
    "supportsVariants": true,
    "scopedSerializationKey": "scopedStyles",
    "query": "styleId",
    "supportsComponentInnerElements": true,
    "featureType": "Component",
    "namespace": "style",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "isRelationalSplitFromQuery": true,
    "supportOverrides": true,
    "signature": "08415ab9830569a8000cb870c705ecd6"
  },
  "themeConfig": {
    "namespace": "themeConfig",
    "mapName": "themeConfig",
    "featureType": "Site",
    "supportsVariants": false,
    "query": "themeConfigQuery",
    "hasFeaturePublicAPI": true,
    "isPublicViewerData": false,
    "signature": "f55b06ba2956d930a13d1cb3f590b0e3"
  },
  "transformations": {
    "mapName": "transformations_data",
    "supportsVariants": true,
    "scopedSerializationKey": "scopedTransformations",
    "query": "transformationQuery",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "namespace": "transformations",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "isRelationalSplitFromQuery": true,
    "supportOverrides": true,
    "signature": "6ce4697f77ecd228d4f9844ac8a0acf9"
  },
  "transitions": {
    "mapName": "transitions_data",
    "supportsVariants": true,
    "scopedSerializationKey": "scopedTransitions",
    "query": "transitionQuery",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "namespace": "transitions",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "isRelationalSplitFromQuery": true,
    "supportOverrides": true,
    "signature": "79680596fc32a1321c672c3fd8878c86"
  },
  "triggers": {
    "namespace": "triggers",
    "mapName": "triggers",
    "supportsVariants": false,
    "query": "triggersQuery",
    "featureType": "Component",
    "supportsComponentInnerElements": true,
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "signature": "67568237c3c3c868e6b9fb55ee2acc07"
  },
  "variables": {
    "namespace": "variables",
    "mapName": "variables",
    "supportsVariants": true,
    "isRelationalSplitFromQuery": false,
    "query": "variablesQuery",
    "featureType": "Component",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "supportOverrides": true,
    "signature": "bc77a967bed2b2b32e88b91818314b68"
  },
  "variants": {
    "mapName": "variants_data",
    "namespace": "variants",
    "query": "breakpointVariantsQuery",
    "featureType": "Component",
    "hasFeaturePublicAPI": false,
    "isPublicViewerData": true,
    "signature": "d8ac52d2053328bb95294f7cc5f0e317"
  }
}
